export type TutorialTask = 'direction' | 'group' | 'schedule' | 'athlete' | 'hub'
export const TUTORIAL_EVENT = 'procoach:tutorial-task'
export const TUTORIAL_RESTART = 'procoach:tutorial-restart'
export function tutorialTaskDone(task: TutorialTask, resourceId?: string) {
  window.dispatchEvent(new CustomEvent(TUTORIAL_EVENT, { detail: { task, resourceId } }))
}
export function restartTutorial() {
  window.dispatchEvent(new Event(TUTORIAL_RESTART))
}
